import React from 'react';
import { AspectRatio, Box, Center, Image, Text } from '@chakra-ui/react';

import { useImaginationRoom } from '@invitato/imagination-room';
import useLang from '@/hooks/useLang';
import {
  GIRL_NAME,
  BOY_NAME,
  IG_GIRL,
  IG_BOY,
  GIRL_PARENT_NAME,
  BOY_PARENT_NAME,
  IS_BOY_FIRST,
  GIRL_NAME_SHORT,
  BOY_NAME_SHORT,
} from '@/constants';

import kawungImg from '@/assets/icons/kawung.svg';

import { ENABLE_LOVE_STORY } from '@/constants/feature-flags';
import { ASSETS_FLOWER_2, ASSETS_KAWUNG_SIMBOL, IMG_COUPLE } from '@/constants/assets';
import WithAnimation from '@/components/Common/WithAnimation';
import { TEXT_PROPS } from '@/constants/default-props';
import InstagramButton from '@/components/Common/InstagramButton';
import { BG_LAYER, BUTTON_PADDING_PROPS } from '@/constants/colors';

function SinglePhoto({ ...rest }) {
  const { onGetFinalName } = useImaginationRoom();
  const lang = useLang();

  const RenderInfo = ({ shortName, fullName, parentName, instagramId }) => (
    <Box height="60%" pos="relative" pt="32px" zIndex="5" textAlign="center">
      <WithAnimation delay={500} type="zoom">
        <Text {...TEXT_PROPS.heading}>{shortName}</Text>
      </WithAnimation>
      <WithAnimation delay={600}>
        <Text {...TEXT_PROPS.body} fontSize="20px" dangerouslySetInnerHTML={{ __html: fullName }} />
      </WithAnimation>
      <WithAnimation delay={650} type="zoom">
        <Image src={ASSETS_KAWUNG_SIMBOL} maxW="25px" mx="auto" />
      </WithAnimation>
      <WithAnimation delay={700}>
        <Text {...TEXT_PROPS.body} dangerouslySetInnerHTML={{ __html: parentName }} />
      </WithAnimation>
      {instagramId && (
        <Center marginTop="24px">
          <WithAnimation delay={700}>
            <InstagramButton
              id={instagramId}
              text={instagramId}
              color="white"
              onlyIcon={false}
              size="md"
              {...BUTTON_PADDING_PROPS}
              fontSize="md"
            />
          </WithAnimation>
        </Center>
      )}
    </Box>
  );

  const DETAIL_BRIDE = {
    instagramId: IG_GIRL,
    fullName: onGetFinalName('brideFullName', GIRL_NAME),
    shortName: onGetFinalName('brideName', GIRL_NAME_SHORT),
    parentName: GIRL_PARENT_NAME[lang],
  };

  const DETAIL_GROOM = {
    instagramId: IG_BOY,
    fullName: onGetFinalName('groomFullName', BOY_NAME),
    shortName: onGetFinalName('groomName', BOY_NAME_SHORT),
    parentName: BOY_PARENT_NAME[lang],
  };

  return (
    <Box minHeight="100vh" position="relative" {...rest}>
      <Box
        padding="48px 0 24px 0"
        width="100%"
        minHeight={{ '3sm': '100vh', '2sm': '90vh', '1sm': '100vh', sm: '90vh' }}
        pos="relative"
        mt="150px"
        zIndex="2"
        {...rest}
      >
        <Box className="animation__flower" position="absolute" top="60px" left="-90px" zIndex="10">
          <WithAnimation left delay={1000}>
            <Image
              src={ASSETS_FLOWER_2}
              width={{ '3sm': '240px', '2sm': '260px', sm: '180px' }}
              transform="rotate(16deg)"
            />
          </WithAnimation>
        </Box>

        <Box
          className="animation__flower"
          position="absolute"
          top="200px"
          right="-100px"
          zIndex="10"
        >
          <WithAnimation right delay={1100}>
            <Image
              src={ASSETS_FLOWER_2}
              width={{ '3sm': '240px', '2sm': '240px', sm: '180px' }}
              transform="rotateY(180deg)"
            />
          </WithAnimation>
        </Box>

        <Box pos="relative" mx="auto" width={{ lg: '70%', base: '80%' }} zIndex="3">
          <WithAnimation>
            <Box
              borderRadius="16px"
              border="1px solid"
              borderColor="bgSecondary"
              bgColor={BG_LAYER}
              minHeight="50vh"
              padding="24px"
              my="24px"
              {...TEXT_PROPS.body}
              textAlign="center"
            >
              {/* photo frame */}

              <Box height="40%" marginTop="-150px">
                <WithAnimation type="zoom" delay={500}>
                  <AspectRatio ratio={3 / 4} maxWidth="400px">
                    <Image
                      src={IMG_COUPLE}
                      maxWidth="100%"
                      borderRadius="16px"
                      border="3px solid"
                      borderColor="bgSecondary"
                    />
                  </AspectRatio>
                </WithAnimation>
              </Box>
              <RenderInfo {...(IS_BOY_FIRST ? DETAIL_GROOM : DETAIL_BRIDE)} />
              <Box h="24px" />
              <RenderInfo {...(IS_BOY_FIRST ? DETAIL_BRIDE : DETAIL_GROOM)} />
            </Box>
          </WithAnimation>
        </Box>
      </Box>
      {!ENABLE_LOVE_STORY && (
        <Box
          width="100%"
          height={{ lg: '150px', '3sm': '150px', '1sm': '220px', sm: '200px' }}
          position="relative"
          zIndex="1"
        >
          <Box
            pos="absolute"
            bottom="0"
            width="100%"
            height="80%"
            bgImage="linear-gradient(to top, #FFF7ED, transparent)"
            zIndex="2"
          />
          <Box
            pos="absolute"
            bottom="0"
            left="0"
            width="100%"
            height={{ '3sm': '60%', '2sm': '40%', sm: '30%' }}
            bgImage={kawungImg}
            bgSize="contain"
            bgPos="top center"
            bgRepeat="repeat-x"
            zIndex="5"
          />
        </Box>
      )}
    </Box>
  );
}

export default SinglePhoto;
